import { useEffect, useState } from "react";
import { Button, Card, Field, Input, Textarea } from "../../shared/ui/index.js";
import { useToast } from "../../shared/toast.js";
import { useUpdateWedding } from "./weddings.api.js";
import type { WeddingRow } from "../../shared/types.js";

export function CoupleForm({ wedding }: { wedding: WeddingRow }) {
  const update = useUpdateWedding(wedding.id);
  const toast = useToast();
  const [p1, setP1] = useState(wedding.partner1Name);
  const [p2, setP2] = useState(wedding.partner2Name);
  const [story, setStory] = useState(wedding.story ?? "");

  useEffect(() => {
    setP1(wedding.partner1Name);
    setP2(wedding.partner2Name);
    setStory(wedding.story ?? "");
  }, [wedding]);

  const dirty =
    p1 !== wedding.partner1Name || p2 !== wedding.partner2Name || story !== (wedding.story ?? "");

  return (
    <Card id="couple">
      <h2 className="font-serif text-lg text-stone-900">Le couple</h2>
      <p className="mt-1 text-sm text-stone-500">Affiché sur la page vue par les invités.</p>

      <div className="mt-4 flex flex-col gap-3">
        <div className="flex flex-col gap-3 sm:flex-row">
          <Field label="Partenaire 1">
            <Input value={p1} onChange={(e) => setP1(e.target.value)} />
          </Field>
          <Field label="Partenaire 2">
            <Input value={p2} onChange={(e) => setP2(e.target.value)} />
          </Field>
        </div>
        <Field label="Votre histoire">
          <Textarea
            rows={3}
            value={story}
            onChange={(e) => setStory(e.target.value)}
            placeholder="Quelques mots pour vos invités…"
          />
        </Field>
        <div>
          <Button
            type="button"
            disabled={!dirty || update.isPending}
            onClick={() =>
              update.mutate(
                { partner1Name: p1, partner2Name: p2, story },
                {
                  onSuccess: () => toast("Modifications enregistrées"),
                  onError: () => toast("Échec de l'enregistrement", "err"),
                },
              )
            }
          >
            {update.isPending ? "Enregistrement…" : dirty ? "Enregistrer" : "Enregistré"}
          </Button>
        </div>
      </div>

      <label className="mt-5 flex items-start gap-3 border-t border-stone-100 pt-4 text-sm">
        <input
          type="checkbox"
          className="mt-0.5"
          checked={wedding.keepOriginals}
          onChange={(e) =>
            update.mutate(
              { keepOriginals: e.target.checked },
              { onSuccess: () => toast("Préférence mise à jour") },
            )
          }
        />
        <span>
          <span className="font-medium text-stone-800">Conserver les fichiers originaux</span>
          <span className="block text-stone-500">
            Les fichiers bruts des invités sont gardés (plus d'espace disque). Sinon, seules les
            versions optimisées sont conservées.
          </span>
        </span>
      </label>
    </Card>
  );
}
